/** Keys for `localStorage` in the mobile app (Capacitor WebView). */
export const LocalStorageMobileKeys = {
  OnboardingSeen: 'onboardingSeen',
  /** Адрес из формы заявки на хранение (гость) — перенос в «Мои адреса» после входа. */
  PendingPickupAddressDraft: 'nebalkon.pendingPickupAddressDraft',
  /** Заявки на хранение/переезд, оставленные без входа — до привязки к аккаунту после OTP. */
  GuestServiceRequests: 'nebalkon.guestServiceRequests',
  /** Очередь редиректов `{ url, action }` — см. `RedirectQueueService`. Значение ключа не менять (данные в WebView). */
  RedirectQueue: 'nebalkon.pendingRedirects',
} as const;
